import React from 'react'
import PropTypes from 'prop-types'
import ProfileLocation from 'components/Profile/ProfileLocation'
import ImageIcon from './ImageIcon'

const Location = ({ iconImg, iconImgAlt, initialLocation, onLocationUpdate }) => (
  <div className="relative mt-2.5 text-black">
    <ImageIcon className="left-8" iconImg={iconImg} iconImgAlt={iconImgAlt} />
    <ProfileLocation
      inputClassName="bg-midnightBlack pl-20 py-5 h-auto"
      inputStyles={{ textAlign: 'left' }}
      initialLocation={initialLocation}
      onLocationUpdate={onLocationUpdate}
    />
  </div>
)

Location.propTypes = {
  iconImg: PropTypes.string,
  iconImgAlt: PropTypes.string,
  initialLocation: PropTypes.string,
  onLocationUpdate: PropTypes.func,
}

export default Location
